module.exports = __webpack_public_path__ + "img/www.apartments.com.e07872fb.png";